<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M4 4l8 8M12 4l-8 8" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'CloseIcon' });
</script>
